import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, Button, Row, Col, Alert } from 'react-bootstrap';
import './BookFormatGuideScreen.css';

function BookFormatGuideScreen() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="layout-guide pb-5">
            <section className="layout-guide__hero mb-4">
                <div>
                    <div className="layout-guide__eyebrow">{t('bookGuide.eyebrow')}</div>
                    <h1>{t('bookGuide.title')}</h1>
                    <p>
                        {t('bookGuide.intro')}
                    </p>
                </div>
                <Button variant="outline-dark" onClick={() => navigate(-1)}>
                    {t('bookGuide.backButton')}
                </Button>
            </section>

            <Alert variant="light" className="layout-guide__alert mb-4">
                <strong>{t('bookGuide.summaryLabel')}</strong> {t('bookGuide.summaryBody')}
            </Alert>

            <section className="layout-guide__photo-grid mb-4">
                <figure className="layout-guide__photo layout-guide__photo--tall">
                    <img src="/site-assets/book-page-stack.jpg" alt={t('bookGuide.photoStackAlt')} />
                </figure>
                <figure className="layout-guide__photo">
                    <img src="/site-assets/book-cover-flat.jpg" alt={t('bookGuide.photoCoverAlt')} />
                </figure>
                <figure className="layout-guide__photo">
                    <img src="/site-assets/book-open-spread.jpg" alt={t('bookGuide.photoSpreadAlt')} />
                </figure>
            </section>

            <Card className="layout-guide__spread-card mb-4 border-0 shadow-sm">
                <Card.Body>
                    <Row className="g-4 align-items-center">
                        <Col lg={7}>
                            <div className="book-spread">
                                <div className="spread-page spread-image">
                                    <img
                                        src="/site-assets/layout-detail-open.jpg"
                                        alt={t('bookGuide.spreadAlt')}
                                        className="spread-img"
                                    />
                                </div>
                                <div className="spread-page spread-text">
                                    <div className="spread-text-content">
                                        <p className="spread-label-right">{t('bookGuide.rhythmLabel')}</p>
                                        <div className="text-page-mockup">
                                            <p className="text-page-title">{t('bookGuide.rhythmTitle')}</p>
                                            <p className="text-page-body">{t('bookGuide.rhythmBody')}</p>
                                            <span className="text-page-number">{t('bookGuide.rhythmSample')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <h2 className="layout-guide__section-title">{t('bookGuide.feelTitle')}</h2>
                            <p className="text-muted mb-3">
                                {t('bookGuide.feelBody')}
                            </p>
                            <ul className="layout-guide__list">
                                <li>{t('bookGuide.feelPoint1')}</li>
                                <li>{t('bookGuide.feelPoint2')}</li>
                                <li>{t('bookGuide.feelPoint3')}</li>
                            </ul>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Row className="g-3 mb-4">
                <Col md={4}>
                    <Card className="layout-guide__info-card h-100 border-0 shadow-sm">
                        <Card.Body>
                            <div className="layout-guide__card-kicker">{t('bookGuide.chooseKicker')}</div>
                            <h3>{t('bookGuide.chooseTitle')}</h3>
                            <p>{t('bookGuide.chooseBody')}</p>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="layout-guide__info-card h-100 border-0 shadow-sm">
                        <Card.Body>
                            <div className="layout-guide__card-kicker">{t('bookGuide.generateKicker')}</div>
                            <h3>{t('bookGuide.generateTitle')}</h3>
                            <p>{t('bookGuide.generateBody')}</p>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="layout-guide__info-card h-100 border-0 shadow-sm">
                        <Card.Body>
                            <div className="layout-guide__card-kicker">{t('bookGuide.assembleKicker')}</div>
                            <h3>{t('bookGuide.assembleTitle')}</h3>
                            <p>{t('bookGuide.assembleBody')}</p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Card className="layout-guide__timeline-card border-0 shadow-sm mb-4">
                <Card.Body>
                    <h2 className="layout-guide__section-title mb-4">{t('bookGuide.checkpointsTitle')}</h2>
                    <div className="layout-guide__timeline">
                        <div className="layout-guide__timeline-item">
                            <div className="layout-guide__timeline-number">1</div>
                            <div>
                                <h3>{t('bookGuide.checkpoint1Title')}</h3>
                                <p>{t('bookGuide.checkpoint1Body')}</p>
                            </div>
                        </div>
                        <div className="layout-guide__timeline-item">
                            <div className="layout-guide__timeline-number">2</div>
                            <div>
                                <h3>{t('bookGuide.checkpoint2Title')}</h3>
                                <p>{t('bookGuide.checkpoint2Body')}</p>
                            </div>
                        </div>
                        <div className="layout-guide__timeline-item">
                            <div className="layout-guide__timeline-number">3</div>
                            <div>
                                <h3>{t('bookGuide.checkpoint3Title')}</h3>
                                <p>{t('bookGuide.checkpoint3Body')}</p>
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Alert variant="light" className="layout-guide__alert border">
                <strong>{t('bookGuide.whyLabel')}</strong>
                <p className="mb-0 mt-2">
                    {t('bookGuide.whyBody')}
                </p>
            </Alert>
        </div>
    );
}

export default BookFormatGuideScreen;
